// extracted by mini-css-extract-plugin
export default {"cModal":"Modal_cModal__b3A+v"};